"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ValidationResult {
    constructor() {
        this.failures = [];
    }
    isValid() {
        return this.failures.length === 0;
    }
    isInvalid() {
        return !this.isValid();
    }
    addFailures(failures) {
        if (failures) {
            this.failures = this.failures.concat(failures);
        }
    }
    getFailures() {
        return this.failures.slice(0);
    }
    getFailureMessages() {
        return this.failures
            .filter(failure => failure.message)
            .map(failure => failure.message);
    }
    getFailureCodes() {
        return this.failures
            .filter(failure => failure.code)
            .map(failure => failure.code);
    }
}
exports.ValidationResult = ValidationResult;
//# sourceMappingURL=ValidationResult.js.map